<template>
  <!-- <div class="h-full flex items-center justify-center">
      <splash-screen/>    
  </div> -->
  <div class="h-full relative">
      <welcome-comp/>
  </div>
</template>

<script>
import SplashScreen from '../../components/SplashScreen.vue'
import WelcomeComp from '../../components/WelcomeComp.vue'
export default {
    components: {
        SplashScreen,
        WelcomeComp
    }
}
</script>
        WelcomeComp

<style>

</style>